import { PageContainer } from '@/components/shared/page-container'
import mocodeaLogo from '@/assets/mocodea-logo.png'
import { env } from '@/lib/env'
import { cn } from '@/lib/utils'

type FooterProps = {
  showGitHash?: boolean
}

export function Footer({ showGitHash = false }: FooterProps) {
  const gitHash = env.gitHash && env.gitHash !== 'unknown' ? env.gitHash : null

  return (
    <footer className="border-t border-border/40 bg-primary-dark/90 backdrop-blur-md py-2">
      <PageContainer className="flex items-center justify-between gap-4 font-body">
        <div className="min-w-0">
          {showGitHash && gitHash ? (
            <span className="font-mono text-[10px] tracking-wide text-muted-foreground/60">{gitHash}</span>
          ) : null}
        </div>

        <a
          href="https://mocodea.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 opacity-60 transition-opacity hover:opacity-100"
        >
          <span className="text-[10px] uppercase tracking-widest text-muted-foreground">Powered by</span>
          <img src={mocodeaLogo} alt="Mocodea" className={cn('h-8 w-auto transition-all [.light_&]:invert')} />
        </a>
      </PageContainer>
    </footer>
  )
}
